module.exports = __webpack_public_path__ + "img/img-thank-you.0a700a2e.jpg";